import React from "react"
import { Link } from "gatsby"
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import Layout from "../components/layout"
import SEO from "../components/seo"

import "./portfolio.css"

const cards = require("../services/dataService").cards
const labels = require("../services/dataService").labels

const Template = ({ pageContext }) => (
  <Layout>
    <SEO title="Portfolio" />

    <h1>Portfolio</h1>
    <p>
      Here's a few of my side-projects i've built in my spare time. You can
      find some of the source code along with other projects on my{" "}
      <OutboundLink href="https://github.com/stebaker92">GitHub</OutboundLink> and my{" "}
      <OutboundLink href="https://gitlab.com/stebaker92">GitLab</OutboundLink>.
      Also check out my <OutboundLink href="https://play.google.com/store/apps/developer?id=SteBakerDev">Google Play</OutboundLink>.
    </p>

    {/* TODO how are these sorted? */}
    {labels
      // .sort((a, b) => a.name.localeCompare(b.name))
      .map(label => (
        <div key={label.id} className="project">
          <h2>{label.name}</h2>
          {cards
            .filter(c => c.labels.find(l => l.id === label.id))
            .map(card => (
              <div key={card.name}>
                <Link to={"/portfolio/" + card.path}>{card.name}</Link>

                {process.env.NODE_ENV === "development" && (
                  <a href={"https://trello.com/c/" + card.id} target="_blank" style={{ marginLeft: '5px' }} rel="noopener noreferrer">
                    [Trello]
                  </a>
                )}

                <div className="description">{card.custom.description}</div>
              </div>
            ))}
        </div>
      ))}
  </Layout>
)

export default Template
